import type { Schema } from "../../..";
import type { Parser } from "../parser";

export class DataPacksParser implements Parser {
	parse(schema: Record<string, Schema.DataPack>) {
		return schema
			? `export type Datapacks = ${Object.keys(schema)
					.map((entry) => `"${entry}"`)
					.join("|")}`
			: "";
	}
}

export class DataPacksCategoryParser implements Parser {
	parse(schema: Record<string, Schema.DataPackCategory>) {
		return schema
			? `export type DatapacksCategories = ${Object.keys(schema)
					.map((entry) => `"${entry}"`)
					.join("|")}`
			: "";
	}
}
